import React, { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";

// Components
import EmergencyDialog from "./EmergencyDialog";
import IntelMode from "./IntelMode";
import SafeSpace from "./SafeSpace";
import UserTypeForm from "./UserTypeForm";

const useStyles = makeStyles(theme => ({
  loading: {
    padding: theme.spacing(4, 5),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 470,
    width: 507
  },
  modal: {
    maxWidth: 835,
    borderRadius: 14
  }
}));

const NewCaseTypeDialog = ({ onClose, onComplete }) => {
  const [userCapacity, setUserCapacity] = useState(null);
  const [showIntel, setShowIntel] = useState(false);
  const [showSafe, setShowSafe] = useState(false);
  const [showEmergency, setShowEmergency] = useState(false);
  const { userDetails } = useSelector(s => s.user);
  const classes = useStyles();

  const handleComplete = () => onComplete(userCapacity);
  const handleNext = isIntel => {
    if (isIntel) setShowIntel(true);
    else setShowSafe(true);
  };

  if (!userDetails)
    return (
      <Dialog PaperProps={{ classes: { root: classes.modal } }} open>
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      </Dialog>
    );
  let component = (
    <UserTypeForm
      handleNext={handleNext}
      handleSelect={setUserCapacity}
      onClose={onClose}
      userType={userDetails.userType}
      value={userCapacity}
    />
  );
  if (showEmergency) {
    component = (
      <EmergencyDialog
        onNext={() => {
          setShowSafe(true);
          setShowEmergency(false);
        }}
      />
    );
  } else if (showSafe) {
    component = (
      <SafeSpace
        userType={userCapacity}
        onCancel={() => setShowSafe(false)}
        onClick={handleComplete}
      />
    );
  } else if (showIntel) {
    component = (
      <IntelMode
        userType={userCapacity}
        onCancel={() => setShowIntel(false)}
        onClick={handleComplete}
      />
    );
  }
  return (
    <Dialog PaperProps={{ classes: { root: classes.modal } }} open>
      {component}
    </Dialog>
  );
};

NewCaseTypeDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired
};

export default NewCaseTypeDialog;
